import { Exception } from './exception';

export class BadLogicException extends Exception {}
